// extracted by mini-css-extract-plugin
module.exports = {"help":"_EditorHelp_help__1EOvO","indent":"_EditorHelp_indent__2lj9_","green":"_EditorHelp_green__1GCPt","blue":"_EditorHelp_blue__20q0l"};